import { render, staticRenderFns } from "./NavWave2.vue?vue&type=template&id=2fc9d02c&scoped=true&"
import script from "./NavWave2.vue?vue&type=script&lang=ts&"
export * from "./NavWave2.vue?vue&type=script&lang=ts&"
import style0 from "./NavWave2.vue?vue&type=style&index=0&id=2fc9d02c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc9d02c",
  null
  
)

export default component.exports